<template>
  <div>
    <hero-bar :has-right-visible="true">
      <div slot="title">Asignaciones</div>
      <div slot="sub-title">Revisar y establecer asignaciones</div>
      <div slot="right">
        <div class="columns">
          <div class="column header-field">
            <assigments-form-create @reload-data="reloadTable = $event" @rider-selected="riderSelected = $event"/>
          </div>
        </div>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <!-- <div class="columns is-vcenter">
        <div class="column is-6">
          <assigments-form-create @reload-data="reloadTable = $event" @rider-selected="riderSelected = $event"/>
        </div>
      </div> -->
      <assignmaents-table slot="content" @edit="editHistory" :reload.sync="reloadTable" :rider-id="riderId"/>
    </section>
    <assignment-edit-modal :active.sync="updateModalActive" :selected-item.sync="selectedItem" :view-mode="viewMode" @reload-data="reloadTable = $event"/>
  </div>
</template>

<script>
import HeroBar from '@/components/HeroBar'
import AssignmaentsTable from './components/AssignmentsTable'
import AssigmentsFormCreate from './components/AssignmentsFormCreate'
import AssignmentEditModal from './components/AssignmentEditModal'

export default {
  components: {
    HeroBar,
    AssignmaentsTable,
    AssigmentsFormCreate,
    AssignmentEditModal
  },
  data () {
    return {
      isComponentModalActive: false,
      riderSelected: null,
      reloadTable: false,
      updateModalActive: false,
      selectedItem: null,
      viewMode: false
    }
  },
  methods: {
    editHistory (data) {
      if (data) {
        this.selectedItem = data
        this.updateModalActive = true
        this.viewMode = false
      }
    }
  },
  computed: {
    riderId () {
      return this.riderSelected ? this.riderSelected.id : null
    }
  }
}
</script>
